<template>
  <div class="three-more-content">
    <div class="three-more-content__headline" v-text="content.headline" />
    <div class="three-more-content__subcopy" v-html="content.subcopy" />
    <div class="three-more-content__media">
      <video
        :src="content.videoUrl"
        ref="video"
        muted
        playsinline
        class="three-more-content__video"
        @ended="handleVideoEnd"
      />
      <!-- controls -->
      <img
        v-if="content.isEnded"
        :src="content.coverImageUrl"
        class="three-more-content__cover"
        alt=""
      />
      <button
        v-show="content.isEnded"
        type="button"
        class="three-more-content__replay"
        @click="handleClickReplay"
      >
        <img src="/theme/rbFront/img/w/magnit/button-replay.png" alt="Replay" />
      </button>
    </div>
    <div class="three-more-content__bodycopy" v-html="content.bodycopy" />
    <div class="three-more-content__disclimer" v-html="content.disclimer" />
  </div>
</template>
<script>
export default {
  name: 'ThreeMoreContent',
  props: {
    isViewportActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    content: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  watch: {
    isViewportActive: {
      handler(val) {
        // 비디오 자동재생/일시정지
        if (val) {
          if (!this.content.isEnded) {
            this.playVideo()
          }
        } else {
          this.pauseVideo()
        }
      },
    },
  },
  activated() {
    // 최초 탭 활성화 시 자동 플레이
    if (this.isViewportActive) {
      this.restartVideo()
    }
  },
  mounted() {},
  methods: {
    handleVideoEnd() {
      this.content.isEnded = true
    },
    handleClickReplay() {
      this.content.isEnded = false
      this.playVideo()
    },
    pauseVideo() {
      this.$refs.video.pause()
    },
    playVideo() {
      this.$refs.video.play()
    },
    restartVideo() {
      this.$refs.video.currentTime = 0
      this.content.isEnded = false
      this.playVideo()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.three-more-content {
  &__headline {
    font-weight: 600;
    font-size: 32px;
  }
  &__subcopy {
    font-size: 24px;
    font-weight: 400;
    color: #000;
    margin-top: 15px;
  }
  &__media {
    position: relative;
    font-size: 0;
    margin-top: 35px;
  }
  &__video {
    width: 100%;
  }
  &__cover {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  &__replay {
    position: absolute;
    bottom: 31px;
    right: 37px;
  }
  &__bodycopy {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    margin-top: 40px;
  }
  &__disclimer {
    font-size: 16px;
    font-weight: 400;
    margin-top: 20px;
  }
  @media screen and (max-width: 1080px) {
    padding: 0 calcQuarter(60);
    &__headline {
      font-size: calcQuarter(64);
    }
    &__subcopy {
      font-size: calcQuarter(56);
      line-height: calcQuarter(70);
    }
    &__media {
      margin-top: calcQuarter(80);
    }
    &__replay {
      width: calcQuarter(154);
      height: calcQuarter(154);
      right: calcQuarter(37);
      bottom: calcQuarter(39);
      img {
        width: 100%;
      }
    }
    &__bodycopy {
      font-size: calcQuarter(56);
      line-height: calcQuarter(70);
      margin-top: calcQuarter(80);
    }
    &__disclimer {
      font-size: calcQuarter(48);
      line-height: calcQuarter(56);
      margin-top: calcQuarter(70);
      color: #727171;
    }
  }
}
</style>
